<template>
  <div class="container">
    <div class="d-flex flex-column">
      <FilterComp />
      <TableComp />
      <PaginationControlsComp />
    </div>
  </div>
</template>

<script>
import FilterComp from "@/components/FilterComp.vue";
import TableComp from "@/components/TableComp.vue";
import PaginationControlsComp from "@/components/PaginationControlsComp.vue";

export default {
  name: "CustomerView",
  components: { FilterComp, TableComp, PaginationControlsComp },
};
</script>

<style scoped></style>
